module.exports = __webpack_public_path__ + "img/stock2.6bd757a3.png";